// plop_marker:layouts_import
import LogosAndHeaderSecurity from "./logos-and-header-security/index.js";
export default {
    // plop_marker:layouts_add_layout
    LogosAndHeaderSecurity
};
